import React, { useEffect, useState } from 'react';
import { Box, Typography, TextField, Button, Divider, Stack } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import ApiService from '../../functions/apiService';
import { toast } from 'react-toastify';

function UserRecall() {
  const [userData, setUserData] = useState({});
  const [loading, setLoading] = useState(false);
  const [eta, setEta] = useState("5");
  const navigate = useNavigate();
  const EnRoute = "E";

  const fetchUserRecallList = async () => {
    try {
      setLoading(true);
      const response = await ApiService.get('/general-recall/employee-list');

      if (response.status === 200) {
        const data = response?.data?.data || {};
        setUserData(data);

        // Check En_Route properly
        if (data?.En_Route === true) {
          navigate('/firehouse/recall-process');
        }
      }
    } catch (error) {
      console.log("List Error:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUserRecallList();
  }, []);

  const handleEtaChange = (e) => {
    const value = e.target.value;
    if (/^\d*$/.test(value)) {
      setEta(value);
    }
  };

  const handleEnRouteClick = async () => {
    try {
      if (!userData || Object.keys(userData).length === 0) return;

      const payload = {
        Shift_Date: userData.Shift_Date,
        Shift_Number: userData.Shift_Number,
        Response: EnRoute,
        Log_Text: eta,
      };

      const res = await ApiService.post("/general-recall/employee-response", payload);

      if (res.status) {
        toast.success(res.message || 'Response recorded successfully');
        navigate('/firehouse/recall-process');
      }
    } catch (err) {
      toast.error(err?.data?.errors || "Something went wrong");
      console.log("Search API Error:", err);
    }
  };

  const noData = Object.keys(userData).length === 0;

  return (
    <>
      {/* Show No Data Message */}
      {noData && !loading && (
        <Box
          sx={{
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div className="d-flex flex-column align-items-center justify-content-center">
            <img src="/images/blur-logo.png" style={{ height: 200, width: 250 }} />
            <span className="mt-4" style={{ color: "#555555" }}>
              Currently there is no recall in progress..
            </span>
          </div>
        </Box>
      )}

      {/* Show Actual Content */}
      {!noData && (
        <Box
          sx={{
            padding: 3,
            border: '1px solid #ccc',
            margin: '20px auto',
            backgroundColor: 'white',
          }}
        >
          <Typography variant="h5" component="h2" sx={{ fontWeight: 'bold', mb: 2 }}>
            General Recall in Progress
          </Typography>

          <Stack direction="row" alignItems="center" spacing={2} sx={{ mb: 3 }}>
            <Typography>ETA: (minutes)</Typography>

            <TextField
              type="number"
              value={eta}
              onChange={handleEtaChange}
              size="small"
              sx={{ width: 80 }}
              inputProps={{ min: 0, step: 1 }}
            />

            <Button
              variant="contained"
              onClick={handleEnRouteClick}
              sx={{ backgroundColor: '#ccc', color: 'black', '&:hover': { backgroundColor: '#bbb' } }}
            >
              En Route
            </Button>
          </Stack>

          <Divider />
        </Box>
      )}
    </>
  );
}

export default UserRecall;
